import React from 'react';
import { colors } from '../../styles/tokens';

export interface RowNumberCellProps {
  rowIndex: number;
  rowId: string | undefined;
  rowSelectionMode: boolean;
  isRowSelected: boolean;
  rowHasSelection: boolean;
  isVisuallySelected: boolean;
  isInterim: boolean;
  // Event handlers
  onMouseDown: (e: React.MouseEvent) => void;
  onMouseEnter: () => void;
  onMouseUp: () => void;
  onClick: (e: React.MouseEvent) => void;
}

/**
 * Row number cell with checkbox for row selection
 */
export const RowNumberCell: React.FC<RowNumberCellProps> = (props) => {
  const {
    rowIndex,
    rowSelectionMode,
    isRowSelected,
    rowHasSelection,
    isVisuallySelected,
    isInterim,
    onMouseDown,
    onMouseEnter,
    onMouseUp,
    onClick,
  } = props;
  // rowId is available via props but not currently used
  const hasAnySelection = isRowSelected || rowHasSelection || isVisuallySelected;

  return (
    <div
      className="flex items-center justify-center text-[11px] text-neutral-400 font-medium select-none cursor-pointer group/rownum hover:bg-neutral-100"
      style={{
        width: '40px',
        minWidth: '40px',
        maxWidth: '40px',
        position: 'sticky',
        left: 0,
        zIndex: 3,
        backgroundColor: isVisuallySelected ? colors.primary[50] : hasAnySelection ? colors.primary[50] : isInterim ? '#f8fafc' : 'white',
        borderRight: `1px solid ${colors.neutral[100]}`,
        transition: 'background-color 100ms ease-out'
      }}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      onMouseUp={onMouseUp}
      onClick={onClick}
    >
      {rowSelectionMode ? (
        // Always show checkbox in row selection mode
        <div
          className="flex w-4 h-4 rounded border-2 items-center justify-center transition-colors"
          style={{
            borderColor: isRowSelected ? colors.primary[500] : colors.neutral[300],
            backgroundColor: isRowSelected ? colors.primary[500] : 'transparent'
          }}
        >
          {isRowSelected && (
            <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          )}
        </div>
      ) : (
        <>
          {/* Show row number normally, checkbox on hover */}
          <span className="group-hover/rownum:hidden">{rowIndex + 1}</span>
          <div
            className="hidden group-hover/rownum:flex w-4 h-4 rounded border-2 items-center justify-center transition-colors"
            style={{
              borderColor: rowHasSelection ? colors.primary[500] : colors.neutral[300],
              backgroundColor: rowHasSelection ? colors.primary[500] : 'transparent'
            }}
          >
            {rowHasSelection && (
              <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
        </>
      )}
    </div>
  );
};

RowNumberCell.displayName = 'RowNumberCell';
